<template>
    <div class="table-sorter-widget" :class="{ inverse:inverse, no_dir:has_no_direction }">
        <a href="#" @click.prevent="desc()" :class="{ active:direction == 'desc' }">
            <i class="fa fa-caret-down" aria-hidden="true"></i>
        </a>
        <a href="#" @click.prevent="asc()" :class="{ active:direction == 'asc' }">
            <i class="fa fa-caret-up" aria-hidden="true"></i>
        </a>
    </div>
</template>

<script>
    export default {
        components: {},
        props: ['inverse', 'field', 'tableName'],
        data() {
            return {
                direction: null
            }
        },
        filters: {},
        watch: {
            direction() {
                window.eventBus.$emit('sort-widget-' + this.tableName, {field: this.field, direction: this.direction});
            }
        },
        computed: {
            has_no_direction() {
                return _.isNull(this.direction);
            }
        },
        methods: {
            asc() {
                if (this.direction == 'asc') {
                    this.direction = null;
                }else{
                    this.direction = 'asc';
                }
            },
            desc() {
                if (this.direction == 'desc') {
                    this.direction = null;
                }else{
                    this.direction = 'desc';
                }
            }
        },
        mounted() {
            var that = this;

            window.eventBus.$on('sort-widget-' + this.tableName, function (details) {
                if (details.field != that.field) {
                    that.direction = null;
                }
            });

        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';

    div.table-sorter-widget {
        display:inline;
        margin-left:5px;
        a {
            opacity: 0.5;
            transition: all 0.1s ease-in-out;
            color: #fff;
            display: inline;
            font-size: 18px;
            &.active, &:hover {
                opacity: 1;
            }
            &:last-of-type{
                margin-left: -3px;
                margin-top: -2px;
            }
        }
        &.inverse {
            a {
                color: $brand;
            }
        }
    }

</style>